export default "__VITE_ASSET__BwJFOVcv__"